// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_bu7","cls2":"CoScientistLandingPage-cls2_Qc3 CoScientistLandingPage-cls1_bu7"};